var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28613 3.07151C5.69307 2.66458 6.13953 2.32125 6.61316 2.04152C8.69608 0.811355 11.3043 0.811355 13.3872 2.04152C13.8608 2.32125 14.3073 2.66458 14.7142 3.07151L10.0002 7.78556L5.28613 3.07151ZM10.0002 5.42854L7.84433 3.2727C9.204 2.62319 10.7964 2.62319 12.156 3.2727L10.0002 5.42854Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10.5479C1.6665 7.93868 2.86566 5.60954 4.74294 4.08154L5.92924 5.26784C4.3502 6.48698 3.33317 8.39866 3.33317 10.5479C3.33317 14.2298 6.31794 17.2146 9.99984 17.2146C13.6818 17.2146 16.6665 14.2298 16.6665 10.5479C16.6665 8.39866 15.6495 6.487 14.0704 5.26786L15.2568 4.08156C17.134 5.60956 18.3332 7.93869 18.3332 10.5479C18.3332 15.1502 14.6022 18.8812 9.99984 18.8812C5.39746 18.8812 1.6665 15.1502 1.6665 10.5479Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.080d413bc6943ba360926d15b6be4b9a.svg";
export { ForwardRef as ReactComponent };